import layoutHeaderAside from '@/layout/header-aside';

const meta = {auth: true};

export default {
    path: '/dataAnalysis',
    name: 'dataAnalysis',
    redirect: { name: 'data-analysis-sqlUpdate' },
    component: layoutHeaderAside,
    meta: meta,
    children: (pre => [
        { 
            path: 'sqlUpdate', 
            name: `${pre}sqlUpdate`, 
            component: () => import('@/pages/dataAnalysis/sqlUpdate'),
            meta: { 
                ...meta, 
                title: 'SQL更新' 
            } 
        },
        { 
            path: 'executeList', 
            name: `${pre}executeList`, 
            component: () => import('@/pages/dataAnalysis/executeList'),
            meta: { 
                ...meta, 
                title: 'SQL执行情况' 
            } 
        }
    ])('data-analysis-')
}